import * as React from 'react';
import { config } from '../../config';
import * as vars from '../../consts/variables';
import { __ } from '../../helpers/TranslationService';
import { validateDDD, validatePhone } from '../../helpers/validation';
import { CountryCodeSelect } from './CountryCodeSelect';
import { Input } from './Input';

interface IProps {
    placeholder: string;
    phoneNumber: string;
    countryCode: string;
    countryCodes: { code: string; label: string; country: string; countryCode: string }[];
    ddd: string;
    isSubmitted: boolean;
    onPhoneChange(event: React.ChangeEvent<any>): void;
    onDDDChange(event: React.ChangeEvent<any>): void;
    onCountryCodeChange(value: string): void;
    portalId: string;
    firstInvalidFormField: string;
    testSelectorName?: string;
}

export class PhoneSelection extends React.Component<IProps, {}> {
    onCountryCodeChange = (selected: { value: string; label: string }) => {
        this.props.onCountryCodeChange(selected.value);
    };

    getOptionsForCountryCodeSelect = () =>
        this.props.countryCodes.map((item) => ({
            value: item.code,
            label: item.label,
            icon: item.countryCode ? `${config.images}/common/flags/${item.countryCode}.svg` : null,
        }));

    render() {
        const {
            isSubmitted,
            phoneNumber,
            onPhoneChange,
            ddd,
            onDDDChange,
            countryCode,
            portalId,
            firstInvalidFormField,
        } = this.props;
        const options = this.getOptionsForCountryCodeSelect();
        const isDDDShown =
            countryCode === vars.brasilCountryCode ||
            (countryCode === '' && portalId === 'dreamlines.com.br');

        const isCountryCodeError = isSubmitted && this.props.countryCode.length === 0;
        const isPhoneError = isSubmitted && !validatePhone(phoneNumber);
        const isDDDError = isSubmitted && !validateDDD(ddd);

        const countryCodeOptions = {
            onChange: this.onCountryCodeChange,
            options: options,
            value: options.find((item) => item.value === this.props.countryCode),
            placeholder: __('mobile.personalData.countryCode', 'dreamlines'),
            isError: isCountryCodeError,
            testSelectorName: 'countrySelect',
        };

        const phoneProps = {
            placeholder: this.props.placeholder,
            value: phoneNumber,
            onChange: onPhoneChange,
            isError: isPhoneError,
            isFirstInvalidFormField: firstInvalidFormField === 'phoneNumber',
            type: 'tel',
            testSelectorName: 'phoneNumber',
            mask: getMaskByCountry(portalId, countryCode),
            maskPlaceholder: '_ _ _ - _ _ _ - _ _ _ _',
        };

        const dddProps = {
            placeholder: __('personalData.DDD', 'dreamlines'),
            value: ddd,
            onChange: onDDDChange,
            isError: isDDDError,
            isFirstInvalidFormField: firstInvalidFormField === 'DDD',
            testSelectorName: 'ddd',
        };

        return (
            <div className="phone-select">
                <CountryCodeSelect {...countryCodeOptions} />
                {isDDDShown && <Input {...dddProps} />}
                <div className="phone-input">
                    <Input {...phoneProps} />
                </div>
            </div>
        );
    }
}

const getMaskByCountry = (portalId, countryCode) => {
    if (portalId !== 'dreamlines.com' || countryCode !== '+1') return '';

    return [
        /[0-9]/,
        ' ',
        /[0-9]/,
        ' ',
        /[0-9]/,
        ' ',
        '-',
        ' ',
        /[0-9]/,
        ' ',
        /[0-9]/,
        ' ',
        /[0-9]/,
        ' ',
        '-',
        ' ',
        /[0-9]/,
        ' ',
        /[0-9]/,
        ' ',
        /[0-9]/,
        ' ',
        /[0-9]/,
    ];
};
